import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${props => props.theme.colors.outline.default};
  margin-bottom: -32px;
  padding: ${props => `${props.theme.spacing.sp16} 24px`};
  border-radius: ${props => props.theme.primitives.radius.radius6} ${props => props.theme.primitives.radius.radius6}
    ${props => props.theme.primitives.radius.radius0} ${props => props.theme.primitives.radius.radius0};
  z-index: 2;
`
